/* 任务链 ↔ 分包卡共用的任务状态徽标 */
export const STATE_BADGE = {
  ready: ["当前", "Current", "bg-brand-500 text-white"],
  done: ["完成 ✓", "Done ✓", "bg-emerald-600/90 text-white"],
  skipped: ["跳过", "Skipped", "bg-slate-300 text-slate-600"],
  blocked: ["阻塞", "Blocked", "bg-red-100 text-red-700 border border-red-300"],
  waiting_time: ["待时间", "Time", "bg-amber-400 text-slate-900"],
  waiting_external: ["等外部", "External", "bg-blue-600 text-white"],
  pending: ["排队", "Queued", "bg-slate-200 text-slate-500"],
  locked: ["锁定", "Locked", "bg-slate-100 text-slate-400"],
};

export const STAGE_BADGE = {
  pending: ["未开始", "Pending", "bg-slate-100 text-slate-500"],
  notified: ["待填工期", "Notified", "bg-blue-100 text-blue-700"],
  in_progress: ["施工中", "In progress", "bg-amber-100 text-amber-700"],
  completed_pending: ["完工待检", "Awaiting inspection", "bg-purple-100 text-purple-700"],
  inspecting: ["检查中", "Inspecting", "bg-orange-100 text-orange-700"],
  closed: ["已验收", "Closed", "bg-green-100 text-green-700"],
};

export const badge = (map, key, zh) => {
  const [bzh, ben, cls] = map[key] || map.pending;
  return { label: zh ? bzh : ben, cls };
};
